import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import {
  CreateTaskWithRoutesPayload,
  RoutesWithField,
} from 'app/containers/Task/slice/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAreaWithUnits } from 'utils/helpers';
import { useRouteCheck } from './useRouteCheck';
import { useRouteDelete } from './useRouteDelete';
import { api } from 'app/api';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { useGetRoutesWithoutTaskFromState } from 'app/containers/Task/pages/RoutesWithoutTaskPage/hooks/useGetRoutesWithoutTaskFromState';
import { selectHiddenOnMapGpsVehicleIds } from 'app/containers/Map/slice/selectors';

export const useRoutesWithoutTaskListCard = ({
  routesWithImplement,
}: {
  routesWithImplement?: CreateTaskWithRoutesPayload | null;
}) => {
  const { t } = useTranslation();

  const envId = useSelector(selectSelectedEnvId) as number;
  const seasonId = useSelector(selectSelectedSeasonId) as number;
  const hiddenGpsVehicleIds = useSelector(selectHiddenOnMapGpsVehicleIds);

  const { routes, isRoutesFetching } = useGetRoutesWithoutTaskFromState();

  const {
    data: fieldsResponse,
  } = api.endpoints.getFieldsGeometry.useQueryState({
    envId,
    seasonId,
    companyId: null,
    companyGroupId: null,
  });

  const routesWithFields: RoutesWithField[] = routes
    .map(route => ({
      routes: [route],
      field: fieldsResponse?.features.find(
        fieldFeature =>
          (route.fieldSeasonId || route.nextFieldSeasonId) ===
          fieldFeature.properties.id,
      ),
    }))
    // Filter out unchecked transport
    .filter(
      ({ routes }) => !hiddenGpsVehicleIds.includes(routes[0].gpsVehicle.id),
    );

  const { onRouteDelete } = useRouteDelete();

  const {
    isAllRoutesChecked,
    checkedRouteIds,
    onRoutesCheck,
    onToggleAllRoutes,
  } = useRouteCheck({ routes });

  const [
    isAddRouteToTaskDrawerVisible,
    setIsAddRouteToTaskDrawerVisible,
  ] = useState(false);

  const getRouteArea = (routeId: number) => {
    const routeWithImplement = routesWithImplement?.find(
      routeWithImplement => routeWithImplement.routeId === routeId,
    );
    if (routeWithImplement?.completedArea) {
      const areaText = getAreaWithUnits(routeWithImplement.completedArea);
      return { areaText, area: routeWithImplement.completedArea };
    }
    return { areaText: '', area: 0 };
  };

  return {
    onRoutesCheck,
    t,
    onRouteDelete,
    setIsAddRouteToTaskDrawerVisible,
    onToggleAllRoutes,
    isAllRoutesChecked,
    checkedRouteIds,
    getRouteArea,
    isAddRouteToTaskDrawerVisible,
    routes,
    isRoutesFetching,
    routesWithFields,
  };
};
